// @flow
// @flow-runtime warn
import { useState, useCallback, useEffect } from 'react';
import inc from 'ramda/es/inc';
import keys from 'ramda/es/keys';

import { api, requestsGeneral } from 'app/api';

import type { StatementsType, StatementSubmitType } from './StatementsTypes';


export const defaultStatementsState = {};
export const defaultStatementsLimit = 5;

export default function useStatementsData(
  autoRequest?: boolean = true,
  limit?: number = defaultStatementsLimit
) {
  const [statements, setStatements] = useState<StatementsType>(defaultStatementsState);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCarrentPage] = useState(0);
  const [endOfList, setEndOfList] = useState(false); // когда запрошены все данные

  /**
   *  ЗАПРОС ОБРАЩЕНИЙ
   */

  const handleRequestStatements = useCallback(async (
    append?: boolean = false,
    offset_?: number = 0,
    limit_?: number = limit
  ) => {
    const statementsRes: StatementsType | null = await api.request(requestsGeneral.Statements_GET_posts, {
      error: 'Не удалось получить обращения',
      onChangeLoadingState: setLoading,
      params: {
        limit: limit_,
        offset: offset_,
      },
    });
    if (statementsRes) {
      setStatements(state => (append ? { ...state, ...statementsRes } : statementsRes));
      if (keys(statementsRes).length < limit_) {
        // пришло меньше данных, чем запрашивали, -- дотигнут конец списка
        setEndOfList(true);
      }
      return true;
    }
    return false;
  }, [limit]);

  // autorequest
  useEffect(() => {
    if (autoRequest) {
      handleRequestStatements(false);
    }
  }, [autoRequest]);

  /**
   *  ЗАПРОС ОБРАЩЕНИЙ, СЛЕДУЮЩАЯ ПОРЦИЯ
   */

  const handleRequestNextStatements = useCallback(async () => {
    setCarrentPage(inc);
    const shift = inc(currentPage) * limit;
    const res = await handleRequestStatements(true, shift, limit);
    return res;
  }, [currentPage, handleRequestStatements, limit]);

  /**
   *  ОТПРАВКА ОБРАЩЕНИЯ НА СЕРВЕР
   */

  const handleSubmitStatement = useCallback(async (submitData: StatementSubmitType) => {
    const statementsRes: StatementsType | null = await api.request(requestsGeneral.Statements_POST_new, {
      error: 'Не удалось сохранить обращение',
      params: submitData,
    });
    if (statementsRes) {
      setStatements(state => ({ ...state, ...statementsRes }));
      return true;
    }
    return false;
  }, []);

  return [
    [statements, loading, endOfList], {
      handleRequestStatements,
      handleRequestNextStatements,
      handleSubmitStatement,
    },
  ];
}
